import { useContext } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";

export default function OneTestimony({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: 'view',
      subItem: 'testimonials',
      extraItem: data.uuid,
    });
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "280px", // Fixed height for a uniform slider look
        padding: "32px",
        cursor: "pointer",
        background: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        borderRadius: "24px",
        transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
        border: "1px solid rgba(255, 255, 255, 0.4)",
        boxShadow: "0 10px 30px -10px rgba(0,0,0,0.05)",
        position: "relative",
        overflow: "hidden"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
        e.currentTarget.style.boxShadow = "0 20px 40px -15px rgba(59, 130, 246, 0.15)";
        e.currentTarget.style.borderColor = "rgba(59, 130, 246, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0) scale(1)";
        e.currentTarget.style.boxShadow = "0 10px 30px -10px rgba(0,0,0,0.05)";
        e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
      }}
    >
      {/* Decorative Gradient Blob */}
      <div style={{
        position: "absolute",
        top: "-20px",
        right: "-20px",
        width: "80px",
        height: "80px",
        background: "linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 51, 234, 0.1) 100%)",
        borderRadius: "50%",
        filter: "blur(20px)"
      }} />

      <div>
        {/* Modern Star Rating */}
        <div style={{ display: "flex", gap: "4px", marginBottom: "16px" }}>
          {[...Array(5)].map((_, i) => (
            <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#3b82f6">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
            </svg>
          ))}
        </div>

        {/* Message */}
        <p style={{
          color: "#1e293b",
          fontSize: "1.05rem",
          lineHeight: "1.6",
          fontWeight: "450",
          margin: 0,
          display: "-webkit-box",
          WebkitLineClamp: "4",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          position: "relative",
          zIndex: 1
        }}>
          {data.message}
        </p>
      </div>

      {/* Client Info Section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginTop: "20px"
        }}
      >
        <div 
          style={{
            width: "52px",
            height: "52px",
            borderRadius: "16px", // Modern "Squircle" instead of a perfect circle
            overflow: "hidden",
            background: "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
            flexShrink: 0,
            border: "2px solid #fff",
            boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
          }}
        >
          <img 
            src={(CDN_URL + data.clientPhoto)} 
            alt={data.client}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${data.client}&background=3b82f6&color=fff` }}
          />
        </div>

        <div style={{ overflow: "hidden" }}>
          <h4 
            style={{
              color: "#0f172a",
              margin: 0,
              fontSize: "1rem",
              fontWeight: "700",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis"
            }}
          >
            {data.client}
          </h4>
          <p 
            style={{
              color: "#64748b",
              fontSize: "0.85rem",
              margin: 0,
              fontWeight: "500"
            }}
          >
            {data.role}
          </p>
        </div>
      </div>
    </div>
  );
}